<wl-footer
  [appNavigation]="appNavigation()"
  [webNavigation]="webNavigation()"
  [usefulLinks]="usefulLinks()"
  [logo]="{
    url: basePath,
    label: logoLabel,
    height: logoSizing.height,
    width: logoSizing.width,
  }"
  [currentYear]="currentYear"
  [brandName]="brandName"
/>
